import type { Group } from './types';

/** The pages that live inside a team. */
export type GroupSection = 'board' | 'activity' | 'releases' | 'settings';

const SECTIONS: GroupSection[] = ['board', 'activity', 'releases', 'settings'];

/**
 * Teams are addressed by slug, so a pasted link reads as the team it opens and a
 * bookmark keeps pointing at the same board. The URL is an address, never a
 * credential: the server re-checks membership on every request, so knowing a
 * slug grants nothing.
 */
export function groupPath(group: Group, section: GroupSection = 'board'): string {
  return `/g/${group.slug}/${section}`;
}

/**
 * Resolves the `:groupKey` segment. Slugs are what links carry; the id is
 * accepted too so anything already sitting in someone's history keeps working.
 */
export function findGroup(groups: Group[], key: string | undefined): Group | undefined {
  if (!key) return undefined;
  return groups.find((group) => group.slug === key) ?? groups.find((group) => group.id === key);
}

/** Which section a path is on, so switching teams stays on the same page. */
export function sectionOf(pathname: string): GroupSection {
  const segment = /^\/g\/[^/]+\/([^/?#]+)/.exec(pathname)?.[1];
  return SECTIONS.find((section) => section === segment) ?? 'board';
}
